import React from "react";
import { useField } from "formik";
import { useDispatch } from "react-redux";

// material
import {
  Box,
  Container,
  FormControl,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  Link,
  MenuItem,
  RadioGroup,
  Radio,
  Typography,
  Stack,
} from "@mui/material";

// components
import Page from "../../../components/Page";
import { FormatUnderlined } from "@material-ui/icons";

// ----------------------------------------------------------------------

export default function OutputSubmissionPageInfo(props) {
  const {
    formField: { statementReportGuideline },
  } = props;

  const [statementReportGuidelineField, statementReportGuidelineMeta] =
    useField(statementReportGuideline);

  return (
    <Page title="PART: Grade/Progress/Final Report">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Report Guideline</Typography>
        </Box>
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <List>
            <ListItem sx={{ textDecoration: "underline" }}>
              <ListItemText
                primary="1) Required Output for C2F PhD Scholarship"
                primaryTypographyProps={{ variant: "h5" }}
              />
            </ListItem>
            <ListItem>
              <Typography
                variant="subtitle1"
                sx={{ paddingTop: 1, paddingLeft: 1 }}
              >
                1. Science field
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                Normal course (3 years):<b> 1 paper of Tier 1 publication </b>
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                Continuing course (5 years):
                <b> 1 paper of Tier 1 and 1 paper of Q1 publication</b>
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="subtitle1" sx={{ paddingLeft: 1 }}>
                2. Social Science and Humanities
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                Normal course (3 years): <b>1 paper of Q1 publication</b>
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                Continuing course (5 years):{" "}
                <b>1 paper of Q1 and 1 paper of Q2 publication</b>
              </Typography>
            </ListItem>

            <ListItem sx={{ textDecoration: "underline" }}>
              <ListItemText
                primary="2) Jounal Ranking Database"
                primaryTypographyProps={{ variant: "h5", paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography>
                C2F accepts from 3 international journal ranking database:
                <b>
                  Scimago (SJR), CiteScore (Scopus), and Journal Citation Report
                  (Web of Science).
                </b>
              </Typography>
            </ListItem>

            <ListItem sx={{ textDecoration: "underline" }}>
              <ListItemText
                primary="3) The authorship and affiliation of publication submitted to C2F"
                primaryTypographyProps={{ variant: "h5", paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                A PhD grantee requires to be a "First author".
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                A mentor requires to be a "Corresponding author".
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                Collaborator(s) from Top 100 University Ranking/ Subject Ranking
                or Top institute or High performance professor can be
                "Co-Author" or else. (**Ranking reference is QS or Times Higher
                Education)
              </Typography>
            </ListItem>
            <ListItem>
              <Typography sx={{ paddingLeft: 4 }}>
                Affliation has to identify "Chulalongkorn University".
              </Typography>
            </ListItem>

            <ListItem sx={{ textDecoration: "underline" }}>
              <ListItemText
                primary="4) The acknowledgement"
                primaryTypographyProps={{ variant: "h5", paddingTop: 1 }}
              />
            </ListItem>
            <ListItem>
              <Typography>
                Please state:
                <b>
                  “This research project is supported by the Second Century Fund
                  (C2F), Chulalongkorn University”.
                </b>
              </Typography>
            </ListItem>

            <ListItem>
              <ListItemText
                primary="5) A Phd grantee, who submits the published article to C2F before ending of the contract, is required to submit 6 month progress report until the end of the contract.
                "
                primaryTypographyProps={{ variant: "h5", paddingTop: 1 }}
              />
            </ListItem>

            <ListItem>
              <ListItemText
                primary="6) When A grantee completes this online report, it will be automatically sent to your email, mentor's email, and C2F system."
                primaryTypographyProps={{ variant: "h5", paddingTop: 1 }}
              />
            </ListItem>

            <ListItem>
              <Typography variant="subtitle1" sx={{ paddingTop: 2 }}>
                ** Please kindly check the completion before submitting to the
                system, C2F is not responsible for any incompletion of the
                report.
              </Typography>
            </ListItem>
          </List>
          {/* เพิ่มตรงเน้ มองงสิ มองงงง */}

          <FormControl fullWidth sx={{ paddingLeft: 2 }}>
            <Typography variant="subtitle2">
              Have you read entire statement in report guideline? *
            </Typography>
            <RadioGroup
              row
              name={statementReportGuidelineField.name}
              value={statementReportGuidelineField.value}
              onChange={(e) => statementReportGuidelineField.onChange(e)}
            >
              <FormControlLabel
                value="yes"
                control={<Radio />}
                label="Yes, I have read and accepted."
              />
            </RadioGroup>
            {statementReportGuidelineMeta.touched && (
              <span
                style={{
                  color: "#FF4842",
                  lineHeight: 1.5,
                  fontSize: "0.75rem",
                  fontFamily: "sans-serif",
                  fontWeight: 400,
                  textAlign: "left",
                  marginTop: "3px",
                  marginRight: "14px",
                  marginBottom: 0,
                  marginLeft: "14px",
                }}
              >
                {statementReportGuidelineMeta.error}
              </span>
            )}
          </FormControl>
        </Stack>
      </Container>
    </Page>
  );
}
